import React from 'react';
import { makeStyles } from "@mui/styles";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import { Formik } from "formik";
import InputMask from "react-input-mask";
import { HelpOutlineRounded as HelpIcon } from "@mui/icons-material";
import * as Yup from "yup";

const initialValues = {
    code: "",
}

const DialogFormChangeCode = (props) => {
    const {
        isOpen,
        onClose,
        onAccept,
    } = props;

    const classes = useStyles();
    const refFormik = React.useRef( null );

    const onSubmit = (form) => {
        onAccept( form.code );
        handleCloseModal();
    };

    const handleCloseModal = () => {
        onClose();
    };

    const handleChange = ({ target }) => {
        const { name, value } = target;
        const newForm = refFormik.current.values;

        newForm[name] = value;

        refFormik.current.setValues( newForm );
    };
    return (
        <Dialog
            open={ isOpen }
            fullWidth
            maxWidth="md"
            onClose={ handleCloseModal }
        >
            <DialogTitle>
                <Typography variant="h3">
                    Ввод кода
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Formik
                    innerRef={ refFormik }
                    initialValues={ initialValues }
                    validationSchema={ validationSchema }
                    onSubmit={ onSubmit }
                >
                    { (props) => {
                        const {
                            values,
                            errors,
                            touched,
                            handleSubmit
                        } = props;

                        return (
                            <>
                                <Box pt={ 1 }>
                                    <Box className={ classes.rowContent }>
                                        <InputMask
                                            mask="999999"
                                            value={ values.code }
                                            maskChar=""
                                            onChange={ handleChange }
                                        >
                                            { () =>
                                                <TextField
                                                    value={ values.code }
                                                    error={ Boolean( touched.code && errors.code ) }
                                                    helperText={ touched.code && errors.code }
                                                    name="code"
                                                    label="Код"
                                                    placeholder="000000"
                                                    variant="outlined"
                                                    fullWidth
                                                />
                                            }
                                        </InputMask>
                                        <Tooltip title="Введите код который сообщат Вам">
                                            <HelpIcon fontSize="small"
                                                      color={ Boolean( touched.code && errors.code ) ? "error" : "primary" }/>
                                        </Tooltip>
                                    </Box>
                                </Box>

                                <DialogActions>
                                    <Button variant="outlined" onClick={ handleCloseModal }>Отменить</Button>
                                    <Button variant="contained"
                                            onClick={ handleSubmit }>Подтвердить</Button>
                                </DialogActions>
                            </>
                        );
                    } }
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

const useStyles = makeStyles( {
    rowContent: {
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
} );

const validationSchema = Yup.object().shape( {
    code: Yup.string()
        .matches( /^[0-9]{6}$/, "Код состоит из 6-ти символов" )
        .required( 'Введите код который сообщат Вам' ),
} );

export default DialogFormChangeCode;
